import {
  createContext,
  useState,
  useMemo,
  useContext,
} from "react";

export const CaptureContext = createContext(null);

export function useCaptureContext() {
  const context = useContext(CaptureContext);
  if (!context) {
    throw new Error("useCaptureContext must be used within a CaptureProvider");
  }
  return context;
}

export function useCaptureCtx() {
  // Global loading state
  const [captureComponent, setCaptureComponent] = useState(true);
  
  const contextValue = useMemo(
    // Memo so if another component calls it doesn't re-run context unless changed
    () => ({
      captureComponent,
      setCaptureComponent,
    }),
    [
      captureComponent,
      setCaptureComponent,
    ]
  );

  return {
    ...contextValue,
  };
}

export default useCaptureCtx; // Export the hook as default for backward compatibility
